export default "__VITE_ASSET__BYS8I2Ct__"